import React from 'react';

function Layout({children}) {
    return (
        <div className="container">
            {children}
        </div>
    );
}

export default Layout;
